import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { ConfirmService } from '../../../core/services/confirm.service';
import { ModalShell } from '../modal-shell/modal-shell';

/** Renders ConfirmService's current prompt above whatever modal asked for it. */
@Component({
  selector: 'hntr-confirm-host',
  imports: [ModalShell, NgIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @let req = confirm.pending();
    <hntr-modal-shell
      [open]="!!req"
      width="440px"
      backdropClass="confirm-backdrop"
      [label]="req?.title ?? ''"
      (closeRequested)="confirm.answer(false)"
    >
      @if (req) {
        <div class="modal-hdr">
          <div class="modal-hdr-left">
            <div class="modal-icon mi-amber" aria-hidden="true">
              <ng-icon name="tablerAlertTriangle" />
            </div>
            <div>
              <h2>{{ req.title }}</h2>
            </div>
          </div>
        </div>
        <div class="modal-body confirm-body">{{ req.message }}</div>
        <div class="modal-footer">
          <button type="button" class="btn-ghost" (click)="confirm.answer(false)">{{ req.cancelLabel }}</button>
          <button type="button" class="btn-save" (click)="confirm.answer(true)">{{ req.confirmLabel }}</button>
        </div>
      }
    </hntr-modal-shell>
  `,
})
export class ConfirmHost {
  protected readonly confirm = inject(ConfirmService);
}
